import styled from 'styled-components';
import { breakpoints } from '@vfit/shared/themes';
import { IGradient } from '@vfit/consumer/data-access';

export const Wrapper = styled.div<{
  isMobileOrTablet?: boolean;
  width?: number;
}>`
  display: flex;
  position: relative;
  ${({ isMobileOrTablet, width }) =>
    isMobileOrTablet
      ? 'padding: 0 24px'
      : `
      width: ${width || `405px`};
    `};

  .image-container {
    height: 100%;
    position: absolute;
    z-index: -1;
    overflow: hidden;
    border-radius: 20px;
  }
`;

export const Container = styled.div<{
  width?: number;
  backgroundColor?: string;
  backgroundGradient?: IGradient;
}>`
  background: ${(props) =>
    props.backgroundGradient &&
    props.backgroundGradient.starColor &&
    props.backgroundGradient.endColor
      ? `linear-gradient(${props.backgroundGradient.angle || 0}deg, ${
          props.backgroundGradient.starColor
        }, ${props.backgroundGradient.endColor})`
      : props.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: deafult;

  border-radius: 20px;
  cursor: pointer;
  width: 100%;
  padding: 32px;
  gap: 32px;
  height: fit-content;

  @media (min-width: ${breakpoints.desktop}) {
    gap: 32px;
    padding: 80px 32px 32px;
    width: ${(props) => (props.width ? `${props.width}px` : '405px')};
  }
`;

export const TopContainer = styled.div`
  width: 100%;
`;

export const BottomContainer = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  font-size: 22px;
  color: white;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  margin-bottom: 12px;

  @media (min-width: ${breakpoints.desktop}) {
    margin-bottom: 8px;
  }
`;

export const AnchorArrowContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
`;

